// extracted by mini-css-extract-plugin
export default {"requirements":"bottom-module--requirements--faf22","copyright":"bottom-module--copyright--6693d","requirementsLink":"bottom-module--requirementsLink--30d1c"};